import React, { useState } from 'react'
import { HashLink } from 'react-router-hash-link'
import Icon from '../../ui/Icon/Icon'
import scrollWithOffset from '../../ui/ScrollToTop/scrollWithOffset'
import './CookieNotification.sass'

function CookieNotification() {
  const [acceptedCookie, setAcceptedCookie] = useState(
    localStorage.getItem('acceptedCookies')
  )

  const onCookiesAccept = () => {
    localStorage.setItem('acceptedCookies', true)
    setAcceptedCookie(true)
  }

  return !acceptedCookie ? (
    <div className="Site-CookieNotification">
      <div className="CookieNotification-Container">
        <div className="CookieNotification-Button">
          <Icon name="times" onClick={onCookiesAccept} />
        </div>
        <div className="CookieNotification-Text">
          Этот сайт использует файлы cookie и похожие технологии, чтобы
          гарантировать максимальное удобство пользователям. При использовании
          данного сайта, вы подтверждаете свое согласие на использование файлов
          cookie в соответствии с этого сообщением относительно данного типа
          файлов Если вы не согласны с тем, чтобы мы использовали данный тип
          файлов, то вы должны соответствующим образом установить настройки
          Вашего браузера или не использовать этот сайт.
        </div>
      </div>
    </div>
  ) : null
}

export default CookieNotification
